class MeshDataModel {
  loaded: boolean;
  constructor() {
    this.loaded = false;
  }
  setLoaded(arg: boolean) {
    this.loaded = arg;
  }
  isLoaded() {
    return this.loaded;
  }
}

const meshDataModel = new MeshDataModel();

export default meshDataModel;
